<div class="card saf-card">
  <div class="d-flex">
    <section class="conversation-list">
      <div class="header-logo">
        <img
          src="/assets/icon-ai-assistant.svg"
          class="ai-icon"
          alt="AI Assistant" />
        <h1 class="fs-23 fw-700 pt-2 color-primary">
          <a href="/" (click)="($event.stopPropagation); resetConvoId()"
            >Smart Assistant Feed</a
          >
        </h1>
      </div>

      <div class="filters my-3">
        <div
          class="d-flex flex-row justify-content-between align-items-center pb-2">
          <div class="filters-label">Applied Filters:</div>
          <button
            type="button"
            class="btn btn-link"
            (click)="showFilterModal()">
            Edit Filters
          </button>
        </div>
        <div class="filters-wrapper">
          <div class="input-group p-2 center">
            <input
              #searchHistory
              type="search"
              class="form-control"
              placeholder="Search by keyword..."
              aria-label="Search"
              [style.lineHeight]="'1.4'"
              [value]="searchTerm"
              (input)="searchTermChanged($event)" />
          </div>
          <app-smart-assistant-filter-container
            [smartAssistantFeedFilters]="smartAssistantFeedFilters"
            (filterRemoved)="removeFilter($event)"
            (filterListRemoved)="
              removeFilterFromList($event)
            "></app-smart-assistant-filter-container>
        </div>
      </div>

      <ng-container *ngIf="conversations; else isLoading">
        <ng-container *ngIf="conversations.length < 1">
          <div
            class="d-flex flex-column justify-content-center align-items-center"
            style="min-height: 500px">
            <div class="fs-22 fw-500">No Results Found</div>
            <p class="fs-12">Please check your filters and try again.</p>
          </div>
        </ng-container>

        <div class="conversations">
          <ng-container *ngFor="let conversation of conversations">
            <div
              [class.selected]="selectedConversation?.id == conversation.id"
              class="convo-item fs-12"
              (click)="getConversation(conversation.id)">
              <div class="d-flex justify-content-start align-items-top">
                <app-avatar
                  [profile]="conversation.user!.profile"
                  avatarSize="small" />
                <div class="ms-2">
                  <div class="fs-13 fw-600">
                    {{ conversation.user!.profile.first_name }}
                    {{ conversation.user!.profile.last_name }}
                  </div>
                  <div class="fs-14 pt-1">
                    <app-safehtml
                      [html]="conversation.title"
                      [removeMargin]="true"
                      [classList]="['mb-1', 'me-2']"></app-safehtml>
                  </div>
                  <div class="fs-12">
                    {{ getChatHistoryDisplayDate(conversation.updated_at) }}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- // PAGINATION -->
        <div
          *ngIf="feedMeta.totalCount > 10"
          class="pagination d-flex justify-content-center mt-2">
          <ngb-pagination
            [(page)]="smartAssistantFeedFilters.page"
            [pageSize]="smartAssistantFeedFilters.per_page"
            [collectionSize]="feedMeta.totalCount"
            (pageChange)="handlePageChange()"
            [maxSize]="5"
            [ellipses]="true"></ngb-pagination>
        </div>
      </ng-container>
    </section>
    <section class="conversation">
      <ng-container *ngIf="!conversationLoading">
        <ng-container *ngIf="selectedConversation; else noConvo">
          <div class="conversation-header">
            <div class="d-flex justify-content-between align-items-center">
              <h2 class="fs-28 fw-700">
                {{ selectedConversation.title }}
              </h2>
              <div class="form-check form-switch">
                <label class="form-check-label" for="flexSwitchCheckChecked"
                  >Show Data</label
                >
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  [(ngModel)]="showDataPanel" />
              </div>
            </div>
          </div>
          <ng-container *ngFor="let message of detailedFeedMessages">
            <ng-container *ngIf="message.role === 'user'">
              <div class="message-wrapper d-flex justify-content-end">
                <div class="message user-message">
                  <div class="message-content">
                    <markdown>{{ message.content }}</markdown>
                  </div>
                  <ng-container *ngFor="let file of message.files">
                    <div class="file-attachment">
                      {{ file.name }}
                    </div>
                  </ng-container>

                  <div
                    class="feed-data"
                    [ngClass]="{
                      show: showDataPanel
                    }">
                    <div class="d-flex justify-content-between">
                      <div class="me-5">
                        <strong>Mode</strong>:
                        {{ message.parsed_full.modes }}
                      </div>
                      <div class="mb-3">
                        {{ message.created_at * 1000 | date : "full" }}
                      </div>
                    </div>
                  </div>
                </div>
                <app-avatar
                  [profile]="selectedConversation.user!.profile"
                  avatarSize="small" />
              </div>
            </ng-container>
            <ng-container *ngIf="message.role === 'assistant'">
              <div class="message-wrapper">
                <div class="d-flex justify-content-start align-items-center">
                  <div>
                    <img
                      src="/assets/icon-ai-assistant-sm.svg"
                      class="ai-icon me-4"
                      alt="AI Assistant" />
                  </div>
                  <div class="message ai-message">
                    <div *ngIf="message.thinking" class="thinking-content">
                      {{ message.thinking }}
                    </div>
                    <div class="message-content">
                      <markdown>{{ message.content }}</markdown>
                    </div>

                    <div
                      class="feed-data"
                      [ngClass]="{
                        show: showDataPanel
                      }">
                      <div class="d-flex justify-content-between mb-3">
                        <div>
                          {{ message.created_at * 1000 | date : "full" }}
                        </div>
                        <div>
                          <i
                            class="bi px-2"
                            [ngClass]="
                              message.user_feedback === 'thumbs_up'
                                ? 'bi-hand-thumbs-up-fill'
                                : 'bi-hand-thumbs-up'
                            "
                            [class.color-success]="
                              message.user_feedback === 'thumbs_up'
                            "></i>
                          <i
                            class="bi px-2"
                            [ngClass]="
                              message.user_feedback === 'thumbs_down'
                                ? 'bi-hand-thumbs-down-fill'
                                : 'bi-hand-thumbs-down'
                            "
                            [class.color-danger]="
                              message.user_feedback === 'thumbs_down'
                            "></i>
                        </div>
                      </div>

                      <p>
                        <strong>Model Id</strong>:
                        {{ message.parsed_full.model_id }}
                      </p>
                      <div class="d-flex justify-content-between mb-2">
                        <div>
                          <strong>Input tokens</strong>:
                          {{ message.parsed_full.input_tokens | json }}
                        </div>
                        <div>
                          <strong>Output tokens</strong>:
                          {{ message.parsed_full.output_tokens | json }}
                        </div>
                      </div>

                      <hr />

                      <div class="d-flex justify-content-end mb-2">
                        <button
                          class="btn btn-sm btn-outline-primary me-2"
                          (click)="accordion.expandAll()">
                          Expand all
                        </button>
                        <button
                          class="btn btn-sm btn-outline-primary me-2"
                          (click)="accordion.collapseAll()">
                          Collapse all
                        </button>
                      </div>
                      <div ngbAccordion #accordion="ngbAccordion">
                        <div ngbAccordionItem="first">
                          <h2 ngbAccordionHeader class="acc-header">
                            <button ngbAccordionButton>System Prompt</button>
                          </h2>
                          <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                              <ng-template>
                                <pre class="pre-wrap">{{
                                  message.parsed_full.system_prompt
                                }}</pre>
                              </ng-template>
                            </div>
                          </div>
                        </div>
                        <div ngbAccordionItem="second">
                          <h2 ngbAccordionHeader class="acc-header">
                            <button ngbAccordionButton>Tool Config</button>
                          </h2>
                          <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                              <ng-template>
                                <pre class="pre-wrap">{{
                                  message.parsed_full.tool_config.tools | json
                                }}</pre>
                              </ng-template>
                            </div>
                          </div>
                        </div>
                        <div ngbAccordionItem="third">
                          <h2 ngbAccordionHeader class="acc-header">
                            <button ngbAccordionButton>Message History</button>
                          </h2>
                          <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                              <ng-template>
                                <div>
                                  <ng-container
                                    *ngFor="
                                      let mesh of message.parsed_full
                                        .message_history
                                    ">
                                    <div
                                      class="p-3 mb-3 border border-tertiary rounded">
                                      <pre class="pre-wrap">{{
                                        mesh | json
                                      }}</pre>
                                    </div>
                                  </ng-container>
                                </div>
                              </ng-template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template #noConvo>
          <div
            class="d-flex justify-content-center align-items-center"
            style="height: 100%">
            <div class="fs-22 fw-500">No conversation selected</div>
          </div>
        </ng-template>
      </ng-container>
    </section>
    <section class="details">
      <ng-container *ngIf="selectedConversation">
        <div
          class="d-flex flex-column justify-content-center pb-3 align-items-center">
          <app-avatar
            [profile]="selectedConversation.user!.profile"
            avatarSize="xxx-large" />
          <div class="fs-20 fw-600 mt-4">
            {{ selectedConversation.user!.profile.first_name }}
            {{ selectedConversation.user!.profile.last_name }}
          </div>
        </div>

        <div class="mt-4 ms-1">
          <div class="form-group column mb-2">
            <label for="staticEmail" class="col-form-label fw-800"
              >Email
            </label>
            <div class="col-sm-10">
              {{ selectedConversation.user.email }}
            </div>
          </div>

          <div class="form-group column mb-2">
            <label for="staticEmail" class="col-form-label fw-800"
              >Title
            </label>
            <div class="col-sm-10">
              {{ selectedConversation.user.profile.title }}
            </div>
          </div>

          <div class="form-group column mb-2">
            <label for="staticEmail" class="col-form-label fw-800"
              >School
            </label>
            <div class="col-sm-10">
              {{ selectedConversation.user.school?.title }}
            </div>
          </div>

          <div class="form-group column mb-2">
            <label for="staticEmail" class="col-form-label fw-800"
              >District
            </label>
            <div class="col-sm-10">
              {{ selectedConversation.user.district?.title }}
            </div>
          </div>
        </div>

        <div class="details-header">Conversation</div>
        <div class="mt-3 ms-1">
          <div class="form-group column mb-2">
            <label for="staticEmail" class="col-form-label fw-800"
              >conversation id
            </label>
            <div class="col-sm-10">
              {{ selectedConversation.id }}
            </div>
          </div>
          <div class="form-group column mb-2">
            <label for="staticEmail" class="col-form-label fw-800"
              >glai_stream_id
            </label>
            <div class="col-sm-10">
              {{ selectedConversation.glai_stream_id }}
            </div>
          </div>
          <div class="form-group column mb-2">
            <label for="staticEmail" class="col-form-label fw-800"
              >created_at
            </label>
            <div class="col-sm-10">
              {{ selectedConversation.created_at * 1000 | date : "M/dd/yyyy" }}
            </div>
          </div>
        </div>
      </ng-container>
    </section>
  </div>
</div>

<ng-template #isLoading>
  <div class="w-100" style="background-color: #fff; height: 700px">
    <app-loader></app-loader>
  </div>
</ng-template>

<app-smart-assistant-feed-filter-modal
  *ngIf="displayFilterModal"
  (setFilters)="setFilters($event)"
  (modalClose)="closeFilterModal()"
  [initialFilters]="smartAssistantFeedFilters"
  #smartAssistantFeedFilterModal></app-smart-assistant-feed-filter-modal>
